import { ICommEvents } from '@components/communication';
import { IOperationPanelEvents } from '@components/Liveroom/OperationPanel/operation-panel-event';
import { ITeacherBottomEvents } from '@components/Liveroom/TeacherBottomNav/teacher-bottom-event';
import { IWKActionSheetEvents } from '@components/WK/WKActionSheet/wk-action-sheet-events';
import { IWKDialogEvents } from '@components/WK/WKDialog/wk-dialog-events';

import { ICreateContentPanelEvents } from '@components/Liveroom/CreateContentPanel/create-content-panel';
import { useContext, useEffect } from 'blx-react-hooks';
import { createContext } from 'react';
import Bus from './lib/bus';
import { ILiveroomCouponListEvents } from '@components/Liveroom/CouponPanel/liveroom-coupon-list';

// 事件命名规范：大写驼峰 组件名+事件名
interface IGlobalEvent {
  GlobalError: { message?: string; msg?: string; size?: string };
  WKDialog: {
    icon?: string;
    title: string;
    subTitle?: string;
    children?: React.ReactChild;
    okText: string;
    cancelText?: string;
    singleBtn: boolean;
    withBtn: boolean;
  };
  WKFixedBoxHook: {
    xPosition: string;
    yPosition: string;
    xDistance?: number | string;
    yDistance?: number | string;
    zIndex?: number;
    children?: React.ReactChild;
  };

  GlobalAlert: { message: string };
  GlobalClearCoupon: null;
  GlobalClearLectureCoupon: null;
  GlobalPageScroll: {
    top: number;
    bottom: number;
    viewTop: number;
    viewBottom: number;
  };
  GlobalSAASState: {
    isSaaS: boolean;
  };
}

// 这里加上你的新的 Event类型
export type GlobalBusEvents = IGlobalEvent &
  ICommEvents &
  IOperationPanelEvents &
  IWKActionSheetEvents &
  IWKDialogEvents &
  ILiveroomCouponListEvents &
  ITeacherBottomEvents &
  ICreateContentPanelEvents;

export const globalBusContext = createContext<Bus<GlobalBusEvents>>(null as any);

export function useGlobalBus(
  handlers?: { [E in keyof GlobalBusEvents]?: (data: GlobalBusEvents[E]) => any },
  inputs?: any[]
): Bus<GlobalBusEvents> {
  const globalBus = useContext<Bus<GlobalBusEvents>>(globalBusContext);
  useEffect(() => {
    if (handlers) {
      globalBus.on(handlers);
      return () => {
        globalBus.off(handlers);
      };
    } else {
      return;
    }
  }, inputs);
  return globalBus;
}



// WEBPACK FOOTER //
// ./src/services/global-bus.ts